var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRobotDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14H2V2H11V14ZM10 3H3V13H10V3ZM22 13V22H13V13H22ZM21 14H14V21H21V14ZM2 22H11V16H2V22ZM3 17H10V21H3V17ZM22 6.5C22 8.98 19.98 11 17.5 11C15.02 11 13 8.98 13 6.5C13 4.02 15.02 2 17.5 2C19.98 2 22 4.02 22 6.5ZM18 9.96C19.695 9.715 21 8.26 21 6.5C21 4.74 19.695 3.285 18 3.04V9.96ZM17 5.73V3.04C16.005 3.185 15.145 3.74 14.605 4.535L17 5.73ZM17 6.845L14.165 5.435C14.06 5.77 14 6.13 14 6.5C14 8.26 15.305 9.715 17 9.96V6.845Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRobotDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/robot-dashboard.5be315811071b16d1b47f99013cae46e.svg";